import React from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import Footer from '@common/footer';
import { MatchApplyCustomHead } from '@common/customHead';
import MatchDashboard from '@components/match/matchDashboard';

// 내 프로필 > 매칭 현황
const MatchApplyPage = () => {
  return (
    <Layout>
      <MatchApplyCustomHead />
      <Header />
      <Content>
        <MatchDashboard />
      </Content>
      <Footer />
    </Layout>
  );
};

export default MatchApplyPage;
